import { TSize } from '@src/models/common';

export const titleSize = (size: TSize, isMobile?: boolean) => {
  if (size === 'lg') {
    return 'h4';
  }
  return isMobile ? 'h4' : 'primary';
};

export const iconSize = (size: TSize, isMobile?: boolean) => {
  if (size === 'lg') {
    return 24;
  }
  return isMobile ? 16 : 24;
};
